import { useEffect, useState } from "react";

const MIN_TABLE_HEIGHT = 200;

const getViewportHeight = () =>
  window.visualViewport?.height ?? window.innerHeight;

export const useTrackingViewportHeight = (offset: number, fallback = 520) => {
  const [height, setHeight] = useState(() => {
    if (typeof window === "undefined") return fallback;
    return Math.max(MIN_TABLE_HEIGHT, getViewportHeight() - offset);
  });

  useEffect(() => {
    const update = () => {
      setHeight(Math.max(MIN_TABLE_HEIGHT, getViewportHeight() - offset));
    };

    update();
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    window.visualViewport?.addEventListener("resize", update);

    const t1 = window.setTimeout(update, 100);
    const t2 = window.setTimeout(update, 300);

    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
      window.visualViewport?.removeEventListener("resize", update);
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, [offset]);

  return height;
};
